import { combineReducers } from "redux";
import * as actionTypes from "../actions/types";

const initialWhiteboardState = {
  showWhiteboard: false,
  layers: [],
  background: ""
}

const whiteboard_reducer = (state = initialWhiteboardState, action) => {
  switch (action.type) {
    // case actionTypes.SET_SHOW_WHITEBOARD:
    //   return {
    //     ...state,
    //     showWhiteboard: action.payload.showWhiteboard
    //   }
    case actionTypes.SAVE_WHITEBOARD_LAYERS:
      return {
        ...state,
        layers: action.payload.layers
      }
    case actionTypes.SAVE_WHITEBOARD_BACKGROUND:
      return {
        ...state,
        background: action.payload.background
      }
    default:
      return state;
  }
}


const rootReducer = combineReducers({
  whiteboard: whiteboard_reducer,
});

export default rootReducer;
